"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = exports.ProfileIcon = exports.MobileToggle = exports.LayoutContainer = exports.Content = exports.Body = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsBreakpoint = _interopRequireDefault(require("styled-components-breakpoint"));

var _peractoUi = require("@peracto/peracto-ui");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var LayoutContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    height: 100%;\n    min-height: 100vh;\n    flex-direction: column;\n\n    ", ";\n\n    ", " {\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        padding: 0 10px;\n        z-index: 1;\n\n        .sticky-content {\n            position: sticky;\n            top: 0;\n        }\n\n        .peracto-logo {\n            margin-top: 0.8rem;\n            margin-bottom: 0.8rem;\n\n            ", ";\n\n            * {\n                fill: #fff;\n            }\n        }\n\n        a {\n            cursor: pointer;\n\n            &:hover {\n                color: ", ";\n            }\n        }\n    }\n"])), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n       flex-direction: row;  \n    "]))), _peractoUi.Header, (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n                height: 26px;\n                width: 270px;\n                padding: 0 20px;\n            "]))), function (props) {
  return props.theme.admin.colors.brand;
});

exports.LayoutContainer = LayoutContainer;

var Sidebar = _styledComponents["default"].div.attrs(function () {
  return {
    className: 'd-flex flex-column justify-content-between'
  };
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    position: relative;\n    font-family: 'Poppins', sans-serif;\n\n    ", ";\n"])), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        min-height: calc(100vh - 60px);    \n        padding-top: 20px;\n    "]))));

exports.Sidebar = Sidebar;

var Body = _styledComponents["default"].div.attrs(function () {
  return {
    className: 'flex-grow-1 d-flex overflow-hidden'
  };
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));

exports.Body = Body;

var ProfileIcon = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    height: 36px;\n    width: 36px;\n    border-radius: 18px;\n\n    overflow: hidden;\n\n    cursor: ", ";\n\n    img {\n        display: block;\n        width: 100%;\n    }\n"])), function (props) {
  return props.onClick ? 'pointer' : '';
});

exports.ProfileIcon = ProfileIcon;

var MobileToggle = _styledComponents["default"].a(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    margin-right: 5px;\n\n    svg {\n        height: 40px;\n    }\n"])));

exports.MobileToggle = MobileToggle;

var Content = _styledComponents["default"].div.attrs(function () {
  return {
    className: 'overflow-auto flex-grow-1'
  };
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 1400px;\n    margin: 0 auto;\n\n    ", ";\n"])), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        flex-direction: row;  \n    "]))));

exports.Content = Content;